import { HealthcareOrganization } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { createFileDescriptorFromBase64, useTranslate } from '@dreryk/react-common';
import {
   ActionBar,
   appendTestableElementAttributes,
   ButtonVariant,
   Panel,
   StyledFlex,
   TextView,
} from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys, healthcareProviderTranslationKeys } from '../../../translations';
import { HealthcareBasicDataPanel } from '../../common/HealthcareBasicData';
import { HealthcareInstitutionLogo } from '../../common/HelathcareInstitutionLogo/HealthcareInstitutionLogo';
import { RegisterBookNumberTextView } from '../../common/RegisterBookNumberTextView';
import { HealthcareOrganizationTree } from '../tree/HealthcareOrganizationTree';

import { StyledHealthcareOrganizationDataPanelOrganizationDetails } from './HealthcareOrganizationDataPanelOrganizationDetails.styled';

type HealthcareOrganizationDataPanelProps = {
   readonly healthcareOrganization: HealthcareOrganization;
   readonly onUpdateClicked: VoidFunction;
};

export const HealthcareOrganizationDataPanel = (props: HealthcareOrganizationDataPanelProps): JSX.Element => {
   const translate = useTranslate();
   const { logo } = props.healthcareOrganization;

   return (
      <>
         <Panel direction={'column'} gap={'24px'} overflow={'auto'} testId={'healthcareOrganizationContent'}>
            <StyledHealthcareOrganizationDataPanelOrganizationDetails>
               <StyledFlex gap={148} {...appendTestableElementAttributes('healthcareOrganization')}>
                  <RegisterBookNumberTextView value={props.healthcareOrganization.registerBookNumber} />

                  <TextView
                     label={healthcareOrganizationTranslationKeys.registeringAuthority}
                     testId={'registeringAuthority'}
                  >
                     {props.healthcareOrganization.registeringAuthority?.name ??
                        translate(healthcareProviderTranslationKeys.noData)}
                  </TextView>
               </StyledFlex>

               {logo ? (
                  <HealthcareInstitutionLogo
                     fileDescriptor={createFileDescriptorFromBase64(logo.data, logo.fileName, logo.mimeType)}
                  />
               ) : (
                  <div />
               )}
               <HealthcareBasicDataPanel testId={'healthcareOrganizationBasicData'} {...props.healthcareOrganization} />
            </StyledHealthcareOrganizationDataPanelOrganizationDetails>

            <HealthcareOrganizationTree healthcareParentData={props.healthcareOrganization} />
         </Panel>

         <ActionBar.PrimaryButton
            testId='practiceDataUpdate'
            label={healthcareOrganizationTranslationKeys.editOrganizationData}
            onClick={props.onUpdateClicked}
            variant={ButtonVariant.PRIMARY}
         />
      </>
   );
};
